import React from 'react';
import ReactDOM from 'react-dom';

import App from './app.js';
import { inviteBugherd } from './utils';

ReactDOM.render( <App />, document.getElementById( 'app-root' ) );

// Attempt to import the BugHerd overlay script. This will only successfully
// be imported if the environment is appropriate (PPRD).
const imported = inviteBugherd();
if ( imported ) {
    console.log( 'BugHerd enabled. Use the "SEND FEEDBACK" button in the lower right corner of the screen to leave feedback.' );
}
